import { selectWallets, walletsActions } from "Features/wallets";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectWithdraw, withdrawActions } from "Shared/store/withdraw";

const methods = [
	{
		label: "PayPal",
		value: "paypal",
	},
	{
		label: "IBAN",
		value: "iban",
	},
];

export function methodController() {
	const dispatch = useDispatch();
	const rawWallets = useSelector(selectWallets.list);
	const selectedMethod = useSelector(selectWithdraw.method);
	const selectedWallet = useSelector(selectWithdraw.wallet);
	const [wallets, setWallets] = useState([]);

	useEffect(() => {
		if (selectedMethod) {
			dispatch(walletsActions.get(selectedMethod));
		}
	}, [selectedMethod]);

	useEffect(() => {
		if (selectedMethod === "iban") {
			setWallets(
				rawWallets.map((rWallet) => {
					return {
						id: rWallet.id,
						name: rWallet.iban,
						first_name: rWallet.first_name,
						last_name: rWallet.last_name,
						country_id: rWallet.country_id,
						province: rWallet.province,
						address: rWallet.address,
						postcode: rWallet.postcode,
						birthdate: rWallet.birthdate,
						personal_id: rWallet.personal_id,
					};
				}),
			);
			dispatch(withdrawActions.setWallet(null));
		}
		if (selectedMethod === "paypal") {
			dispatch(withdrawActions.setWallet(null));
			setWallets(
				rawWallets.map((rWallet) => {
					return {
						id: rWallet.id,
						name: rWallet.paypal_email,
						first_name: rWallet.first_name,
						last_name: rWallet.last_name,
						country_id: rWallet.country_id,
						province: rWallet.province,
						address: rWallet.address,
						postcode: rWallet.postcode,
						birthdate: rWallet.birthdate,
						personal_id: rWallet.personal_id,
					};
				}),
			);
		}
	}, [rawWallets]);

	function onSelectWallet(wallet) {
		dispatch(withdrawActions.setWallet(wallet));
	}

	function onSelectMethod(method) {
		dispatch(withdrawActions.setMethod(method));
	}
	function onAddNew() {
		dispatch(withdrawActions.setWallet({}));
		dispatch(withdrawActions.setVisibleAddMethod(true));
	}
	function onDeleteWallet(id) {
		dispatch(walletsActions.deleteWallet(id));
	}

	return {
		methods,
		wallets,
		onSelectWallet,
		selectedWallet,
		onSelectMethod,
		selectedMethod,
		onShowModal: onAddNew,
		onDeleteWallet,
	};
}
